import React from "react";
import {FormattedMessage} from "react-intl";

function GroupOrderReviewActionsBar(props) {

    return (
        <div className={props.isVisible ? "actionsbar show" : "actionsbar"}>

            <p className="actionsbar-hint"><FormattedMessage id="SendOrderWhenEveryoneConfirms"/></p>
            <br/>
            <div className="row buttons-row">
                <a className={props.btnClassName} data-qa={props.dataQAIdentifier1} onClick={props.buttonAction}>
                    {props.buttonName}
                </a>
            </div>
        </div>
    );
}

export default GroupOrderReviewActionsBar;
